

export const KEY_OWN_CID = "challenge:own_cid";
export const KEY_TOKEN = "challenge:token";

export const EVENT_OWN_CID_CHANGED = "challenge:own_cid_changed";